import React from 'react'

import TextLink from '../../../../../TextLink'


export default function makeTextLinkRenderer({ dataTid, handleClick }) {
  return function RenderedTextLink(chunks) {
    return (
      <TextLink
        data-tid={ dataTid }
        handleClick={ handleClick }
      >
        { chunks }
      </TextLink>
    )
  }
}
